import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../../../../@core/auth/auth.service';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { GrowerReceiptsDTO } from '../models/grower-receipts-dto';
import { CropYear } from '../../../core/models/cropYear';
import { Crop } from '../../../core/models/crop';

@Injectable({
  providedIn: 'root'
})
export class GrowerReceiptsReportService {
  protected basePath = '/';
  constructor(protected httpClient: HttpClient,
    private authService: AuthService) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  syncReceipts(): Observable<any> {
    return this.httpClient.post(`${this.basePath}/api/StemiltReceipt/sync-receipts?tenant=STMLT5202`, {});
  }

  getAllGrowerReceiptsReportsForSteamilt(year: number, cropNames: string[]): Observable<GrowerReceiptsDTO[]> {
    let queryParameters = new HttpParams()
      .set('year', year.toString());

    cropNames.forEach(name => {
      queryParameters = queryParameters.append('cropNames', name);
    });

    return this.httpClient.get<GrowerReceiptsDTO[]>(
      `${this.basePath}/api/StemiltReceipt/grower-receipts`,
      {
        params: queryParameters
      }
    );
  }
  getCropYears(): Observable<CropYear[]> {
    return this.httpClient.get<CropYear[]>(`${this.basePath}/api/StemiltReceipt/cropYears`);
  }

  getCommodities(): Observable<Crop[]> {
    return this.httpClient.get<Crop[]>(`${this.basePath}/api/StemiltReceipt/commodity`);
  }

  getPackoutPredictor(lotNumber: string, quantity: number, growerId?: number, roomId?: number, cropYear?: number): Observable<any> {

    let queryParameters = new HttpParams()
      .set('quantity', quantity.toString());

    if (lotNumber) {
      queryParameters = queryParameters.set('inputValue', lotNumber);
    }

    if (growerId !== null && growerId !== undefined) {
      queryParameters = queryParameters.set('growerId', growerId.toString());
    }

    if (roomId !== null && roomId !== undefined) {
      queryParameters = queryParameters.set('roomId', roomId.toString());
    }

    if (cropYear !== null && cropYear !== undefined) {
      queryParameters = queryParameters.set('cropYear', cropYear.toString());
    }

    return this.httpClient.get<any>(
      `${this.basePath}/api/StemiltReceipt/packout-predictor`,
      {
        params: queryParameters
      }
    );
  }
}
